import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { H3Dialog, H3Textarea } from "h3-mobile-vue";
import MutilText from "@cloudpivot/form/src/common/components/mutil-text.vue";
import { AIPolishControl } from "./control";
let AIPolishMobile = class AIPolishMobile extends AIPolishControl {
    constructor() {
        super(...arguments);
        this.visible = false;
    }
    /** 获取当前控件允许输入的最大字符数。 */
    get maxLength() {
        return Number(this.controlOpts.maxLength) || 2000;
    }
    /** 将文本框直接编辑的内容写回当前表单数据项（h3-textarea 的 onChange 事件）。 */
    onTextChange() {
        const value = this.polishedText;
        this.ctrl.value = value.length === 0 ? null : value;
    }
    /** 打开移动端 AI 润色弹窗并发起首次润色请求（结果写入弹窗草稿，不改动输入框）。 */
    openDialog() {
        if (this.readonlyFormula || !this.validateSourceBeforeOpen()) {
            return;
        }
        this.visible = true;
        this.errorMessage = "";
        this.generate();
    }
    /** 关闭弹窗并丢弃未应用的润色草稿。 */
    closeDialog() {
        if (!this.loading) {
            this.visible = false;
            this.dialogText = "";
        }
    }
    /** 基于当前润色结果（含用户手动调整）重新发起润色请求。 */
    repolish() {
        this.generate(this.dialogText);
    }
    /** 将润色结果草稿应用进表单输入框并关闭移动端 AI 润色弹窗。 */
    apply() {
        this.polishedText = this.dialogText;
        this.applyPolishedText();
        this.visible = false;
    }
};
AIPolishMobile = tslib_1.__decorate([
    Component({
        name: "AIPolishMobile",
        components: {
            H3Dialog,
            H3Textarea,
            MutilText,
        },
    })
], AIPolishMobile);
export default AIPolishMobile;
